module.exports = __webpack_public_path__ + "img/travel-for-work-bg.e6f03e8d.jpg";